import { useEffect, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InternalGeneralContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetInternalTransactionByIdQuery } from '../../internal/store/services';

const TransactionFeeGeneralContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();
  const [feeValue, setFeeValue] = useState<number | undefined>(undefined);

  const {
    transactionFee: { transaction },
  } = useAppSelector((state) => state);

  const [getTransactionFee, { isLoading }] =
    useLazyGetInternalTransactionByIdQuery();

  const getTransactionFeeAction = useCallback(() => {
    getTransactionFee(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!transaction && transactionId) {
      getTransactionFeeAction();
    }
  }, [getTransactionFeeAction, transaction, transactionId]);

  useEffect(() => {
    if (transaction && !feeValue && transaction.feeAmount) {
      setFeeValue(transaction.feeAmount);
    }
  }, [transaction, feeValue]);

  return (
    <InternalGeneralContent
      isLoading={isLoading}
      general={transaction}
      feeValue={feeValue}
    />
  );
};

export default TransactionFeeGeneralContentHOC;
